import { useQueries } from "@tanstack/react-query";

import { useCan, useSelectedDealer } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { WebhooksQueryKeys } from "modules/WebhooksDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { QueryFunctionContext } from "@tanstack/react-query";
import type { DealerLocation } from "models";
import type { IBackendQueryKey } from "utils/keyFactory";

export const useLocationChecklistsQuery = () => {
  const { selectedDealer } = useSelectedDealer();
  const canListLocations = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Locations);
  const locationIds = selectedDealer?.locations?.map(element => element.id) || [];

  const queries = useQueries({
    queries: locationIds.map(id => ({
      queryKey: [WebhooksQueryKeys.locationChecklist(id)],
      queryFn: async (queryFnParams: QueryFunctionContext<ReadonlyArray<IBackendQueryKey>>) => {
        const { baseUrl, endpoint } = queryFnParams.queryKey[0];

        const response = await ApiInstance.post(endpoint, { id, embed: "checklist" }, baseUrl);
        return response.data;
      },
      enabled: !!selectedDealer?.id && canListLocations
    }))
  });

  const locations: DealerLocation[] = queries.flatMap(query => query.data);
  const locationChecklists = locations.filter(Boolean).map(({ id, checklists }) => ({ id, checklists: checklists || [] }));

  return { locationChecklists, isFetching: queries.some(query => query.isFetching) };
};
